import * as tslib_1 from "tslib";
import { noop } from 'lodash';
import * as React from 'react';
import DataTableBody from './DataTableBody';
import Styles from "./DataTable.css";

function DataTable(_a) {
  var _b = _a.blockName,
      blockName = _b === void 0 ? 'data-table' : _b,
      _c = _a.onSortChange,
      onSortChange = _c === void 0 ? noop : _c,
      sortData = _a.sortData,
      dataTest = _a.dataTest,
      restProps = tslib_1.__rest(_a, ["blockName", "onSortChange", "sortData", "dataTest"]);

  return React.createElement("div", {
    className: Styles.dataTable,
    "data-test": dataTest
  }, React.createElement(DataTableBody, tslib_1.__assign({}, restProps, {
    onSortChange: onSortChange,
    sortData: sortData
  })));
}

export default React.memo(DataTable);